/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import html2canvas from "html2canvas";

// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import moment from 'moment';
import { AxiosGet, AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import AverageChart from './components/AverageChart';
import JobTypeChart from './components/JobTypeChart';
import BAbarChart from './components/BAbarChart';
import BApieChart from './components/BApieChart';
import TopEmployee from './components/TopEmployee';
import StackedBarChart from './components/StackedBarChart';
import StackedColumnChart from './components/StackedColumnChart';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import { BtnExportExcel, BtnIconSearch, BtnSearch } from 'components/Common/Button';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';

const SatisFactionReport = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [sBA, setsBA] = useState("")
    const [optionBA, setoptionBA] = useState([] as any);
    const [optionJobType, setoptionJobType] = useState([] as any);
    const [optionVOCType, setoptionVOCType] = useState([] as any);

    const [dataAverage, setdataAverage] = useState(null);

    const [dataJobType, setdataJobType] = useState([] as any)

    const [dataBA, setdataBA] = useState([] as any)

    const [dataBApie, setdataBApie] = useState([]) as any

    const [dataTopEmp, setdataTopEmp] = useState(null) as any
    const [dataStackColumn, setDataStackColumn] = useState(null) as any
    const [dataTypeOfVOC, setDataTypeOfVOC] = useState(null) as any
    const [ImgChart, setImgChart] = useState([] as any);
    const [nCountAllDiv, setnCountAllDiv] = useState(0)

    //#region  Form
    let objSchema = {
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        arrTypeJob: yupFormSchemas.stringArray("ประเภทใบงาน", { required: false }),
        arrTypeVOC: yupFormSchemas.stringArray("Type of VOC", { required: false }),
        arrDateIssue: yupFormSchemas.stringArray("วันที่แจ้ง", { required: true }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        // form.setValue("arrDateIssue", [new Date(new Date().getFullYear(), new Date().getMonth(), 1), null])
        let today = new Date();
        form.setValue("arrDateIssue", [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth(), today.getDate())])

        onGetOptionAll();
    }, [])


    useEffect(() => {
        let gDiv1_1 = document.querySelectorAll('[id^="pie_avg"]').length;     //1
        let gDiv1_2 = document.querySelectorAll('[id^="bar_"]').length;    //3
        let gDiv2 = document.querySelectorAll('[id^="ba-pie_"]').length;       //4
        let gDiv3 = document.querySelectorAll('[id^="bar-jobtype"]').length;       //6
        let gDiv4 = document.querySelectorAll('[id^="StackedBarChart"]').length;       //1
        let gDiv5 = document.querySelectorAll('[id^="bar-ba"]').length;
        let gDiv6 = document.querySelectorAll('[id^="topEmp_"]').length;
        let gDiv7 = document.querySelectorAll('[id^="StackedColumnChart"]').length;
        let nCountAllDiv = gDiv1_1 + gDiv1_2 + gDiv2 + gDiv3 + gDiv4 + gDiv5 + gDiv6 + gDiv7
        setnCountAllDiv(nCountAllDiv)
    }, [document.querySelectorAll('[id^="pie_avg"]'), document.querySelectorAll('[id^="bar_"]'), document.querySelectorAll('[id^="ba-pie_"]'), document.querySelectorAll('[id^="bar-jobtyp"]'), document.querySelectorAll('[id^="StackedBarChart"]')
    , document.querySelectorAll('[id^="bar-ba"]'), document.querySelectorAll('[id^="topEmp_"]'), document.querySelectorAll('[id^="StackedColumnChart"]')])


    const onLoadData = async (isSet = true) => {
        BlockUI();
        setImgChart([]);
        if (isSet == true) {
            let formBA = form.getValues("arrBA") || []
            if (formBA.length === 4) {
                setsBA("GBU")
            }
            else {
                let arrBA = optionBA.filter(f => formBA.includes(f.value)).map(item => item.label);
                setsBA(arrBA.join(', '))
            }
        }

        let obj = {
            "lstBA": form.getValues("arrBA") || [],
            "lstJobType": form.getValues("arrTypeJob") || [],
            "lstVOCType": form.getValues("optionVOCType") || [],
            "sDateIssueStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sDateIssueEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        await onAverageChart(obj)
        await GetDataBAbar(obj);
        await GetDataTopEmployee(obj)
        UnBlockUI();

    }

    const onAverageChart = async (obj) => {
        await AxiosPost(`Report/GetAllAverageScore`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataAverage(res.oAverage)
                setdataBApie(res.oBAGraphPie)
                setdataJobType(res.oJobTypeGraphPie)
                setDataTypeOfVOC(res.oTypeOfVOC)
                setDataStackColumn(res.oNotSatisfaction)
            })
        });
    }

    const GetDataTopEmployee = async (obj) => {
        await AxiosPost(`Report/GetDataTopEmployee`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataTopEmp(res)
            })
        });
    }

    const GetDataBAbar = async (obj) => {
        AxiosPost(`Report/GetDataBAbar`, obj, (res) => {
            ResultAPI(res, null, () => {
                setdataBA(res.lstDataGraph)
            })
        });
    }

    const onGetOptionAll = async () => {
        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionBA(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrBA", arrValue)

                    if (arrOption.length === 4) {
                        setsBA("GBU")
                    }
                    else {
                        let arrBA = arrOption.map(item => item.label);
                        setsBA(arrBA.join(', '))
                    }
                }
            })
        });
        await AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionJobType(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrTypeJob", arrValue)
                }
            })
        });
        await AxiosGet(`BAService/GetBAType`, {}, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionVOCType(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrTypeVOC", arrValue)
                }
            })
        });

        await onLoadData(false);
    }

    const onhandleInput = () => {
        setImgChart([]);
    }

   

    const ExportFileExcel = () => {

        if (ImgChart.length > 0) {
            if (nCountAllDiv === ImgChart.length) {
                let Param = {
                    "lstBA": form.getValues("arrBA") || [],
                    "lstJobType": form.getValues("arrTypeJob") || [],
                    "lstVOCType": form.getValues("arrTypeVOC") || [],
                    "sDateIssueStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
                    "sDateIssueEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
                    "ImgChart": ImgChart,

                }
                let sFileName = `รายงานสรุปคะแนนความพึงพอใจ_${moment().format("DDMMYYYYHHmmss")}`;
                AxiosPostFileExcel(`ExportReport/ExportSatisFactionReport`, Param, sFileName, null, null, BlockUI, UnBlockUI)
            }
        }
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<QueryStatsRoundedIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="รายงาน"
                label_nameRoute="สรุปคะแนนความพึงพอใจ"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    {/* Search */}
                    <FormProvider {...form}>
                        <div className='div-border'>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start">
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={optionBA}
                                        label={'กลุ่มตลาด'}
                                        required={false}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrTypeJob"
                                        options={optionJobType}
                                        label={'ประเภทใบงาน'}
                                        required={false}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrTypeVOC"
                                        options={optionVOCType}
                                        label={'Type of VOC'}
                                        required={false}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} xl={4.5}>
                                    <DateRangePicker
                                        label={"วันที่แจ้ง (เริ่มต้น)"}
                                        lableEnd={"วันที่แจ้ง (สิ้นสุด)"}
                                        require={true}
                                        name="arrDateIssue"
                                        maxDate={moment()}
                                        onChange={() => { onhandleInput() }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={'auto'}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnSearch onClick={form.handleSubmit(() => { onLoadData() })} />
                                        </Grid>
                                        <Grid item>
                                            <BtnExportExcel isDisabled={nCountAllDiv != ImgChart.length} onClick={() => { ExportFileExcel() }} />
                                            {/* <BtnExportExcel onClick={() => { ExportFileExcel() }} /> */}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </FormProvider>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2} >
                        <Grid item xs={12} md={6}>
                            <div className='div-border'>
                                <AverageChart
                                    sBA={sBA}
                                    data={dataAverage}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className='div-border'>
                                <BApieChart
                                    sBA={sBA}
                                    data={dataBApie}
                                    exportImg={(e) => {
                                        setImgChart(item => [...item, e]);
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <JobTypeChart
                                sBA={sBA}
                                data={dataJobType}
                                exportImg={(e) => {
                                    setImgChart(item => [...item, e]);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <StackedBarChart
                                sBA={sBA}
                                data={dataTypeOfVOC}
                                exportImg={(e) => {
                                    setImgChart(item => [...item, e]);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <BAbarChart
                        sBA={sBA}
                        data={dataBA}
                        exportImg={(e) => {
                            setImgChart(item => [...item, e]);
                        }}
                    />
                </Grid>
                <Grid item xs={12} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TopEmployee
                                sBA={sBA}
                                data={dataTopEmp}
                                ImgChart={ImgChart}
                                exportImg={(e) => {
                                    setImgChart(item => [...item, e]);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <StackedColumnChart
                                sBA={sBA}
                                data={dataStackColumn}
                                ImgChart={ImgChart}
                                exportImg={(e) => {
                                    setImgChart(item => [...item, e]);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default SatisFactionReport